import { buildWhatsAppLink } from '@/lib/postgraduate-chat/phone'
import type { ChatAnswers } from '@/lib/postgraduate-chat/chat-flow'

interface ChatWhatsappCtaProps {
  readonly answers: ChatAnswers
  readonly whatsappNumber: string
}

/**
 * CTA final (RN09): direciona para o WhatsApp da plataforma de origem,
 * mantendo o contexto — nome do lead na mensagem.
 */
export function ChatWhatsappCta({ answers, whatsappNumber }: ChatWhatsappCtaProps) {
  const name = answers.name?.trim()
  const message = name
    ? `Olá! Sou ${name}. Acabei de falar com o atendimento pelo site e quero continuar por aqui.`
    : 'Olá! Acabei de falar com o atendimento pelo site e quero continuar por aqui.'

  return (
    <div className="shrink-0 border-neutral-200 border-t p-3">
      <a
        className="flex items-center justify-center gap-2 rounded-full bg-green-500 px-4 py-2.5 font-rethink font-semibold text-sm text-white transition-colors hover:bg-green-600"
        href={buildWhatsAppLink(whatsappNumber, message)}
        rel="noopener noreferrer"
        target="_blank"
      >
        Continuar no WhatsApp
      </a>
    </div>
  )
}
